// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"1323c532","5121":"1323c532","5877":"1323c532","8587":"1323c532","9736":"1323c532"}[chunkId] + ".chunk.css";
};